import { Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, InputGroup, InputLeftElement, Select, Stack, Text, Textarea, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { fleetFormValidation } from '../../utils';
import { fleetType } from '../../types';
import { updateFleet } from '../../store/actions';
import { useFormik } from 'formik';

export const EditFleet = () => {

    const { fleet_id } = useParams();

    const [fleet, setFleet] = useState<fleetType>();

    const { is_updating_fleet, fleets_size, fleets } = useAppSelector(state => state.fleetReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const fleetForm = useFormik({
        initialValues: {
            fleet_size: '',
            fleet_amount: 0,
            per_km: 0,
            loader_amount: 0,
            description: '',
        },
        validationSchema: fleetFormValidation,
        validateOnBlur: true,
        onSubmit: (values: fleetType) => {
            const newValues = { ...fleet, ...values };
            dispatch(updateFleet(newValues)).then(() => navigate('/vehicles/fleets'));
        }
    });

    const setFormFieldValues = () => {

        const [fleet] = fleets?.filter((fleet: fleetType) => fleet?.fleet_id === fleet_id);
        setFleet(fleet);

        fleetForm.setFieldValue('fleet_size', fleet?.fleet_size);
        fleetForm.setFieldValue('fleet_amount', fleet?.fleet_amount);
        fleetForm.setFieldValue('per_km', fleet?.per_km);
        fleetForm.setFieldValue('loader_amount', fleet?.loader_amount);
        fleetForm.setFieldValue('description', fleet?.description);

    };

    useEffect(() => {
        setFormFieldValues();
    }, [fleet]);

    useEffect(() => {}, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/vehicles/fleets' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Edit fleet.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={fleetForm.handleSubmit}>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="fleet_size" isRequired mb={fleetForm.errors.fleet_size ? 0 : 5}>
                                        <FormLabel>Fleet size</FormLabel>
                                        <Select disabled name='fleet_size' placeholder='Select fleet size' value={fleetForm.values.fleet_size} onChange={fleetForm.handleChange} onBlur={fleetForm.handleBlur}>
                                            {
                                                fleets_size?.map((fleet: string, index: number) => (<option key={index} value={fleet}>{fleet}</option>))
                                            }
                                        </Select>
                                        {fleetForm.errors.fleet_size && <Text fontSize='sm' color='red.400'>{fleetForm.errors.fleet_size}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="fleet_amount" isRequired mb={fleetForm.errors.fleet_amount ? 0 : 5}>
                                        <FormLabel>Fleet amount</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents='none'
                                                color='gray.300'
                                                fontSize='1.2em'
                                            >
                                                R
                                            </InputLeftElement>
                                            <Input name='fleet_amount' type="text" value={fleetForm.values.fleet_amount} onChange={fleetForm.handleChange} onBlur={fleetForm.handleBlur} placeholder='Enter fleet amount' />
                                        </InputGroup>
                                        {fleetForm.errors.fleet_amount && <Text fontSize='sm' color='red.400'>{fleetForm.errors.fleet_amount}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="per_km" isRequired mb={fleetForm.errors.per_km ? 0 : 5}>
                                        <FormLabel>Per Km</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents='none'
                                                color='gray.300'
                                                fontSize='1.2em'
                                            >
                                                R
                                            </InputLeftElement>
                                            <Input name='per_km' type="text" value={fleetForm.values.per_km} onChange={fleetForm.handleChange} onBlur={fleetForm.handleBlur} placeholder='Enter per km amount' />
                                        </InputGroup>
                                        {fleetForm.errors.per_km && <Text fontSize='sm' color='red.400'>{fleetForm.errors.per_km}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="loader_amount" isRequired mb={fleetForm.errors.loader_amount ? 0 : 5}>
                                        <FormLabel>Loader amount</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents='none'
                                                color='gray.300'
                                                fontSize='1.2em'
                                            >
                                                R
                                            </InputLeftElement>
                                            <Input name='loader_amount' type="text" value={fleetForm.values.loader_amount} onChange={fleetForm.handleChange} onBlur={fleetForm.handleBlur} placeholder='Enter loader amount' />
                                        </InputGroup>
                                        {fleetForm.errors.loader_amount && <Text fontSize='sm' color='red.400'>{fleetForm.errors.loader_amount}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'100%'}>
                                    <FormControl id="description" isRequired mb={fleetForm.errors.description ? 0 : 5}>
                                        <FormLabel>Description</FormLabel>
                                        <Textarea name='description' noOfLines={3} value={fleetForm.values.description} onChange={fleetForm.handleChange} onBlur={fleetForm.handleBlur} placeholder='Enter description' />
                                        {fleetForm.errors.description && <Text fontSize='sm' color='red.400'>{fleetForm.errors.description}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <Stack spacing={10} mt={3}>
                                <Button
                                    type='submit'
                                    size="lg"
                                    colorScheme={'yellow'}
                                    isLoading={is_updating_fleet}
                                    isDisabled={is_updating_fleet || !fleetForm.isValid}
                                >
                                    {'Submit'}
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};